var map = {
	"./sinon": 300,
	"./sinon.js": 300,
	"./sinon/assert": 303,
	"./sinon/assert.js": 303,
	"./sinon/behavior": 305,
	"./sinon/behavior.js": 305,
	"./sinon/call": 306,
	"./sinon/call.js": 306,
	"./sinon/collection": 307,
	"./sinon/collection.js": 307,
	"./sinon/extend": 308,
	"./sinon/extend.js": 308,
	"./sinon/format": 309,
	"./sinon/format.js": 309,
	"./sinon/log_error": 314,
	"./sinon/log_error.js": 314,
	"./sinon/match": 315,
	"./sinon/match.js": 315,
	"./sinon/mock": 316,
	"./sinon/mock.js": 316,
	"./sinon/sandbox": 317,
	"./sinon/sandbox.js": 317,
	"./sinon/spy": 318,
	"./sinon/spy.js": 318,
	"./sinon/stub": 319,
	"./sinon/stub.js": 319,
	"./sinon/test": 320,
	"./sinon/test.js": 320,
	"./sinon/test_case": 321,
	"./sinon/test_case.js": 321,
	"./sinon/times_in_words": 322,
	"./sinon/times_in_words.js": 322,
	"./sinon/typeOf": 323,
	"./sinon/typeOf.js": 323,
	"./sinon/util/core": 324,
	"./sinon/util/core.js": 324,
	"./sinon/util/event": 326,
	"./sinon/util/event.js": 326,
	"./sinon/util/fake_server": 327,
	"./sinon/util/fake_server.js": 327,
	"./sinon/util/fake_server_with_clock": 328,
	"./sinon/util/fake_server_with_clock.js": 328,
	"./sinon/util/fake_timers": 329,
	"./sinon/util/fake_timers.js": 329,
	"./sinon/util/fake_xdomain_request": 331,
	"./sinon/util/fake_xdomain_request.js": 331,
	"./sinon/util/fake_xml_http_request": 332,
	"./sinon/util/fake_xml_http_request.js": 332,
	"./sinon/util/timers_ie": 333,
	"./sinon/util/timers_ie.js": 333,
	"./sinon/util/xdr_ie": 334,
	"./sinon/util/xdr_ie.js": 334,
	"./sinon/util/xhr_ie": 335,
	"./sinon/util/xhr_ie.js": 335,
	"./sinon/walk": 336,
	"./sinon/walk.js": 336
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 302;



//////////////////
// WEBPACK FOOTER
// ./~/sinon/lib ^\.\/.*$
// module id = 302
// module chunks = 1